var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "toggle-wrapper", class: { multi: _vm.noshrink } },
    [
      _c("span", { staticClass: "caption ft-xbld" }, [
        _vm._v(_vm._s(_vm.caption)),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "toggle-outer" }, [
        _c("div", { staticClass: "bg" }),
        _vm._v(" "),
        _c("div", { staticClass: "toggler", style: _vm.togglerStyle }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "items ft-bld" },
          _vm._l(_vm.items, function (item, key) {
            return _c(
              "span",
              {
                key: item,
                class: { active: _vm.currentItem == key },
                style: _vm.itemStyle,
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.toggleItem(key)
                  },
                },
              },
              [_vm._v(_vm._s(item))]
            )
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }